import React from 'react';
import pick from 'lodash/pick';
import Dictionary from '@prhdigitalgroup/ahab-shared-data';
import { Grid } from '@mui/material';
import { Section, InlineSection } from 'modules/ui';
import { VoiceSkills } from 'modules/talents';
import { DictionaryUtil } from 'modules/dictionary';

function VoiceSkillsSection({
  audition,
  error,
  Placeholder,
  placeholderText = 'Not provided.',
  ...otherProps
}) {
  const voiceSkillsFields = [
    'requiredGender',
    'requiredPrimaryLanguages',
    'requiredAccents',
    'requiredForeignLanguages',
    'requiredEthnicities',
    'requiredRecordingExperiencesIds',
    'requiredVoiceAgeRangesIds',
  ];
  const voiceSkills = pick(audition, voiceSkillsFields);

  const voiceAgeRangeObjs = DictionaryUtil.getDictionaryObjects(
    voiceSkills.requiredVoiceAgeRangesIds,
    Dictionary.VOICE_RANGES,
  );

  const recordingExperienceObjs = DictionaryUtil.getDictionaryObjects(
    voiceSkills.requiredRecordingExperiencesIds,
    Dictionary.RECORDING_EXPERIENCES,
  );

  const genderAndAgeText = VoiceSkills.getGenderAndAgeString(
    voiceSkills.requiredGender,
    voiceAgeRangeObjs,
  );
  const recordingExperienceText = VoiceSkills.getRecordingExperienceString(
    recordingExperienceObjs,
  );

  const foreignLanguagesText =
    voiceSkills.requiredForeignLanguages &&
    voiceSkills.requiredForeignLanguages.join(', ');
  const accentsText =
    voiceSkills.requiredAccents && voiceSkills.requiredAccents.join(', ');

  return (
    <Section title="Voice Skills" {...otherProps}>
      <Grid container spacing={2}>
        <Grid
          size={{
            xs: 12,
            md: 4,
          }}
        >
          <InlineSection
            title="Gender & Vocal Age Range"
            text={genderAndAgeText}
            placeholderText={placeholderText}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 4,
          }}
        >
          <InlineSection
            title="Audiobooks Read"
            text={recordingExperienceText}
            placeholderText="Any"
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 4,
          }}
        >
          <InlineSection
            title="Character cultural background"
            text={
              voiceSkills.requiredEthnicities &&
              voiceSkills.requiredEthnicities.join(', ')
            }
            placeholderText="Any"
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 4,
          }}
        >
          <InlineSection
            title="Primary language"
            text={
              voiceSkills.requiredPrimaryLanguages &&
              voiceSkills.requiredPrimaryLanguages.join(', ')
            }
            placeholderText={placeholderText}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 4,
          }}
        >
          <InlineSection
            title="Language Fluencies"
            text={foreignLanguagesText}
            placeholderText="Language fluencies not provided"
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 4,
          }}
        >
          <InlineSection
            title="Accents"
            text={accentsText}
            placeholderText="Accents not provided"
          />
        </Grid>
      </Grid>
    </Section>
  );
}

export default VoiceSkillsSection;
